module.exports = __webpack_public_path__ + "static/media/kia_1.8b5b84d1.jpg";